"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.project.exceeded': 'Límite de proyectos alcanzado. Actualice su plan para crear más proyectos.',
    'limits.project.limitReached': 'Límite de proyectos: {limit} (actualizar para más)',
};
